<script>
	import { get, set } from 'idb-keyval';
	let task = "";
	let todos = []

	get('todos')
	.then(arr => {
		if(arr !== undefined)
			todos = arr
	})
	

	function addTask() {
		if(task!=""){
			todos.push(task)
			todos = todos;
			set('todos', todos)
			task = ""
		}
	}

	function addNew(event) {
		if (event.which === 13) {
			addTask()
		}
	}

	function removeTask(index) {
		todos = todos.slice(0, index).concat(todos.slice(index + 1));
		set('todos', todos)
		console.log(index);
	}
</script>

<style>
	ul {
		list-style: none;
	}
</style>

<input bind:value={task} on:keydown={addNew}>

<button on:click={addTask}>Add Task</button>

<ul>
	{#each todos as todo, index (todo)}
		<li>
			<input type=checkbox on:click={() => removeTask(index)}>
			{todo}
		</li>
	{/each}
</ul>
